import { useNovaXContract, useAvaPepeContract, useTinyDragonContract } from './useContract'
import { useSingleCallResult } from '../state/multicall/hooks'
import { ChainId, JSBI, TokenAmount } from '@yetiswap/sdk'
import { YTS } from '../constants'
import INFTProperties from '../pages/NFTMarketPlace/models/INFTProperties'

export function useGetNovaXResources(planetId: number, resourceId: number): string {
  const contract = useNovaXContract()
  const resourcesResult = useSingleCallResult(contract, 'getResourceAmount', [resourceId, planetId])
  let result = '0'
  const oneToken = JSBI.BigInt(1000000000000000000)
  const token = YTS[ChainId.BOBA]

  if (!resourcesResult.loading && resourcesResult.result && resourcesResult.result[0]) {
    const tokenAmount = new TokenAmount(
      token,
      JSBI.divide(
        JSBI.multiply(JSBI.BigInt(resourcesResult.result[0]), JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(18))),
        oneToken
      )
    )

    result = tokenAmount.toSignificant(10).toString()
  }
  return result
}

export function useGetMintingReward(tokenId: number): string {
  const contract = useAvaPepeContract()
  const resourcesResult = useSingleCallResult(contract, 'getReflectionBalance', [tokenId])
  let result = '0'
  const oneToken = JSBI.BigInt(1000000000000000000)
  const token = YTS[ChainId.BOBA]

  if (!resourcesResult.loading && resourcesResult.result && resourcesResult.result[0]) {
    const tokenAmount = new TokenAmount(
      token,
      JSBI.divide(
        JSBI.multiply(JSBI.BigInt(resourcesResult.result[0]), JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(18))),
        oneToken
      )
    )

    result = tokenAmount.toSignificant(10).toString()
  }
  return result
}

export function useGetDragonStats(tokenId: number): INFTProperties[] {
  const contract = useTinyDragonContract()
  const resourcesResult = useSingleCallResult(contract, 'getStats', [tokenId])
  let result: INFTProperties[] = []

  if (!resourcesResult.loading && resourcesResult.result && resourcesResult.result[0]) {
    const { baseAttack, baseDefense, attack, defense, level } = resourcesResult.result[0]

    result = [
      {
        key: 'Level',
        value: JSBI.BigInt(level).toString()
      },
      {
        key: 'Base Attack',
        value: JSBI.BigInt(baseAttack).toString()
      },
      {
        key: 'Base Defense',
        value: JSBI.BigInt(baseDefense).toString()
      },
      {
        key: 'Attack',
        value: JSBI.BigInt(attack).toString()
      },
      {
        key: 'Defense',
        value: JSBI.BigInt(defense).toString()
      }
    ]
  }
  return result
}
